<template>
    <div class="noti-list d-flex flex-column">
        <div class="noti-scroll">
            <NotificationRow v-for="n in store.items" :key="n.uuid" :n="n" @opened="$emit('opened')" />
            <div v-if="store.loading" class="pa-4 text-center">
                <v-progress-circular indeterminate size="24" color="accent" />
            </div>
            <div v-else-if="store.load_failed" class="pa-6 text-center text-medium-emphasis">
                {{ t("notifications_load_failed") }}
            </div>
            <div v-else-if="!store.items.length" class="pa-8 text-center text-medium-emphasis">
                <v-icon size="40" class="mb-2">mdi-bell-outline</v-icon>
                <div>{{ t("no_notifications") }}</div>
            </div>
            <div v-if="store.next_offset !== null && store.items.length && !store.loading" class="pa-2 text-center">
                <v-btn variant="text" color="accent" @click="store.loadMore()">{{ t("load_more") }}</v-btn>
            </div>
        </div>
        <div class="noti-foot text-caption text-medium-emphasis">{{ t("notifications_kept_days") }}</div>
    </div>
</template>

<script setup>
import NotificationRow from './NotificationRow.vue'
import { usePitStoreBasics } from '@/stores/app_common'
import { useNotificationsStore } from '@/stores/notifications'

defineEmits(['opened'])
const { t } = usePitStoreBasics()
const store = useNotificationsStore()
</script>

<style scoped>
.noti-list {
    min-height: 0;
    flex: 1;
}

.noti-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.noti-foot {
    flex: none;
    padding: 8px 16px;
    border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
